import ptBRIntl from "antd/lib/locale/pt_BR";
import { ConfigProvider, Switch } from "antd";
import { BetaSchemaForm, ProCard } from "@ant-design/pro-components";
import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import _ from "lodash";
import { actionAcceptLoop } from "../constants/actions";

export default function ActionRender({ action, formAction, saveDataFromActionAfterChangeStep }) {
    const [loading, setLoading] = useState(false);
    const [propsInput, setPropsInput] = useState([])

    useEffect(() => {
        const fetchPropsInput = async () => {
            const props = action.propsInput;
            setPropsInput(props);

            formAction.resetFields();
            let initialValues = action.config ? action.config : null;
            if (initialValues) {
                if (actionAcceptLoop.includes(action.type)) {
                    if (initialValues.loopData === undefined) {
                        initialValues.loopData = {
                            active: false,
                            maxLoop: null,
                            valueReference: null
                        }
                    }
                }
                formAction.setFieldsValue(initialValues);
            }
        }
        fetchPropsInput();
    }, [action.type, action.propsInput, formAction]);


    function handleOnChangeValue(values) {
        saveDataFromActionAfterChangeStep()
    }

    return (
        <React.Fragment>

            {loading &&
                <Loader type={"Circles"}></Loader>
            }

            <ConfigProvider locale={ptBRIntl}>
                {
                    !loading &&
                    action &&
                    <BetaSchemaForm
                        // Coluna única com rótulo acima: o inspector é estreito
                        // e o antigo `layout` recebia um objeto (inválido), o
                        // que caía no horizontal padrão e desalinhava os campos.
                        layout="vertical"
                        layoutType={"Form"}
                        form={formAction}
                        columns={propsInput}
                        submitter={false}
                        onValuesChange={handleOnChangeValue}
                    >
                    </BetaSchemaForm>
                }
            </ConfigProvider>
        </React.Fragment>
    )
}
